/**
 * Not to be confused with the analyst repository - which is focused on the roles of a analyst in an organization.
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const path = `v2/analytics/courses`;
  async function get({ course = null } = {}) {
    return repository
      .get(`${path}${course ? "/" + String(course) : ""}`)
      .then(response => {
        return Promise.resolve(response.data.object);
      });
  }
  return Object.freeze({
    get
  });
}
